import React from "react";
import classes from "./ProjectsHeader.module.css";
import trade from "../../images/trade.jpg";
import event from "../../images/eventLogo.png";
const ProjectsHeader = (props) => {
  return (
    <div className={classes.projectsHeader}>
      <h3
        style={{
          color: "#d9d9d9",
          backgroundColor: "transparent",
          fontSize: "25px",
          marginBottom: 8,
        }}
      >
        Projects Overview
      </h3>
      <p style={{ color: "#b7b7b7", backgroundColor: "transparent" }}>
        On this page, you can find information about my student life, internship
        experiences, and individual projects. At the moment, detailed
        information has not been added to this version of the website.
      </p>
    </div>
  );
};

export default ProjectsHeader;
